/**
 * usePermissionCatalog — GET /api/eraf/permissions 전체 목록 조회.
 *
 * #471: 메뉴 편집/생성 폼의 '필요 권한' 드롭다운 옵션 source.
 * role-management 내부를 import 하지 않고 menuApi 의 axios client 를 재사용한다.
 *
 * queryKey: ['menu-management', 'permissions']
 * staleTime: 5분 (권한 카탈로그는 드물게 변경)
 */
import { useQuery } from '@tanstack/react-query';
import { menuApi } from '../api/menuApi';

export function usePermissionCatalog() {
  return useQuery({
    queryKey: ['menu-management', 'permissions'],
    queryFn: () => menuApi.getPermissions(),
    staleTime: 5 * 60 * 1000,
  });
}
